import styled from 'styled-components';
import { theme } from '../../../../shared/const/theme';
const avatarStyle = `
  position: relative;
  display: flex;
  height: 44px;
  width: 44px;
  border-radius: 100%;
  padding: 0;
  margin: 0;
  border: none;
  background: #f5f5f7;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: initial;

  &:focus-visible {
    outline: ${theme.waffle.colors.outline.focus} auto 1px;
  }
`;
export const AvatarButton = styled.button.withConfig({
    componentId: "sc-6afd5756-0"
})([
    ``,
    ``
], avatarStyle);
export const AvatarLink = styled.a.withConfig({
    componentId: "sc-6afd5756-1"
})([
    ``,
    ``
], avatarStyle);
export const AvatarImage = styled.img.withConfig({
    componentId: "sc-6afd5756-2"
})([
    `position:absolute;width:100%;height:100%;object-fit:cover;`
]); //# sourceMappingURL=Avatar.styled.js.map
